




































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { computed, onMounted, Ref, ref } from "@vue/composition-api";
import AppCheckbox from "@/components/AppCheckbox.vue";
import EmailList from "../shared/EmailList.vue";
import ScheduledButtons from "../scheduled-reports/ScheduledButtons.vue";
import { ReportScheduleOption } from "../data/pdf/model";
type ModalDataType = { keys: string[] };

export default Vue.extend({
  components: {
    Modal,
    AppCheckbox,
    EmailList,
    ScheduledButtons,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "Generate .csv Report For",
      desc: "",
      blank: true,
      width: "60rem",
      height: "auto",
      withTopRightCloseBtn: true,
      submitBtnText: "Generate",
      cancelBtnText: "Cancel",
    };

    const selected_schedule: Ref<ReportScheduleOption> = ref("weekly");

    const email_list = ref<string[]>([]);

    const report_name = ref("");
    const report_description = ref("");

    const schedule_report = () => {
      emit("submit", {
        // @ts-ignore
        name: report_name.value,
        description: report_description.value,
        keys: report_keys.value
          .filter((key) => key.selected)
          .map((key) => key.id),
        subscribers: email_list.value,
        timeFrame: selected_schedule.value,
      });
    };

    const report_keys: Ref<Array<{ id: string; selected: boolean }>> = ref([]);

    const is_valid = computed(
      () =>
        report_keys.value.some((d) => d.selected) &&
        email_list.value.length > 0 &&
        report_name.value.trim().length > 0
    );

    /**
     * removing any html tag
     * */
    const normalize_name = (name: string): string => {
      return name.replace(/<[^>]+>/g, "").replace(/ /g, "_");
    };

    onMounted(() => {
      // @ts-ignore
      report_name.value = normalize_name(props.modalData.title + " Report");
      report_keys.value = (props.modalData as ModalDataType).keys.map((key) => {
        return { id: key, selected: true };
      });
    });

    return {
      config,
      report_name,
      report_description,
      email_list,
      report_keys,
      is_valid,
      selected_schedule,
      schedule_report,
    };
  },
});
